<template>
  <div id="mp-connect">
    <div>
      <h1>Łączenie</h1>
      <hr />
      <div class="row">
        <div class="col-4 border-right">
          <div class="row">
            <div class="col-12">
              <nav>
                <div class="nav nav-tabs" id="nav-config" role="tablist">
                  <a
                    class="nav-item nav-link active"
                    id="nav-global-tab"
                    data-toggle="tab"
                    href="#nav-global"
                    role="tab"
                    aria-controls="nav-global"
                    aria-selected="true"
                  >
                    Ogólne
                  </a>
                  <a
                    class="nav-item nav-link"
                    id="nav-group-tab"
                    data-toggle="tab"
                    href="#nav-group"
                    role="tab"
                    aria-controls="nav-group"
                    aria-selected="false"
                  >
                    Grupy
                  </a>
                  <a
                    class="nav-item nav-link"
                    id="nav-lines-tab"
                    data-toggle="tab"
                    href="#nav-lines"
                    role="tab"
                    aria-controls="nav-lines"
                    aria-selected="false"
                  >
                    Linie
                  </a>
                  <a
                    class="nav-item nav-link"
                    id="nav-points-tab"
                    data-toggle="tab"
                    href="#nav-points"
                    role="tab"
                    aria-controls="nav-points"
                    aria-selected="false"
                  >
                    Punkty
                  </a>
                </div>
              </nav>
              <div class="tab-content" id="nav-tabContent">
                <div class="tab-pane fade show active" id="nav-global" role="tabpanel" aria-labelledby="nav-global-tab">
                  <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" id="fullscreen" v-model="gameJS.fullscreen" />
                    <label class="custom-control-label" for="fullscreen">Gra na pełny ekran (fullscreen)</label>
                  </div>
                  <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" id="checkGame" v-model="gameJS.withoutCheck" />
                    <label class="custom-control-label" for="checkGame">Bez sprawdzania (withoutCheck)</label>
                  </div>
                  <div class="custom-control custom-switch">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      id="removeInCorrects"
                      v-model="gameJS.removeInCorrects"
                    />
                    <label class="custom-control-label" for="removeInCorrects">Usuwaj błędne (removeInCorrects)</label>
                  </div>
                  <div class="custom-control custom-switch">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      id="correctBlock"
                      v-model="gameJS.correctBlock"
                    />
                    <label class="custom-control-label" for="correctBlock">Blokuj poprawne (correctBlock)</label>
                  </div>
                  <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" id="bruteForce" v-model="gameJS.bruteForce" />
                    <label class="custom-control-label" for="bruteForce">Pokazuj odpowiedzi (bruteForce)</label>
                  </div>
                  <div class="custom-control custom-switch">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      id="autoCheckAllCorrect"
                      v-model="gameJS.autoCheckAllCorrect"
                    />
                    <label class="custom-control-label" for="autoCheckAllCorrect">
                      Auto-sprawdzanie (autoCheckAllCorrect)
                    </label>
                  </div>
                </div>
                <div class="tab-pane fade" id="nav-group" role="tabpanel" aria-labelledby="nav-group-tab">
                  <button class="btn btn-primary" type="button" @click="addGroup($event)">
                    <font-awesome-icon :icon="['fas', 'plus-circle']"></font-awesome-icon>
                    Dodaj grupę
                  </button>
                  <div class="accordion" id="accordionGroups">
                    <mp-group-cjs
                      v-for="item in gameJS.layout.groups"
                      :key="item.idGroup"
                      :group="item"
                      :stage="preStage"
                      @changeConfig="onUpdateGame"
                    ></mp-group-cjs>
                  </div>
                </div>
                <div class="tab-pane fade" id="nav-lines" role="tabpanel" aria-labelledby="nav-lines-tab">
                  <div class="form-group form-check">
                    <input type="checkbox" class="form-check-input" id="freeDrawing" v-model="gameJS.freeDrawing" />
                    <label class="form-check-label" for="freeDrawing">Swobodne rysowanie (freeDrawing)</label>
                  </div>
                  <div class="form-group form-check">
                    <input type="checkbox" class="form-check-input" id="hideLine" v-model="gameJS.hideLine" />
                    <label class="form-check-label" for="hideLine">Linia chowa się za element (hideLine)</label>
                  </div>
                  <div class="accordion" id="accordionLines">
                    <div class="card">
                      <div class="card-header" id="headingLineConnect">
                        <h2 class="mb-0">
                          <button
                            class="btn btn-link"
                            type="button"
                            data-toggle="collapse"
                            data-target="#collapseLineConnect"
                            aria-expanded="true"
                            aria-controls="collapseLineConnect"
                          >
                            Linia do połączenia (connect)
                          </button>
                        </h2>
                      </div>
                      <div
                        id="collapseLineConnect"
                        class="collapse show"
                        aria-labelledby="headingLineConnect"
                        data-parent="#accordionLines"
                      >
                        <div class="card-body">Linia do połączenia (connect)</div>
                      </div>
                    </div>
                    <div class="card">
                      <div class="card-header" id="headingLineSelect">
                        <h2 class="mb-0">
                          <button
                            class="btn btn-link collapsed"
                            type="button"
                            data-toggle="collapse"
                            data-target="#collapseLineSelect"
                            aria-expanded="false"
                            aria-controls="collapseLineSelect"
                          >
                            Linia łącząca obiekty (select)
                          </button>
                        </h2>
                      </div>
                      <div
                        id="collapseLineSelect"
                        class="collapse"
                        aria-labelledby="headingLineSelect"
                        data-parent="#accordionLines"
                      >
                        <div class="card-body">Linia łącząca obiekty (select)</div>
                      </div>
                    </div>
                    <div class="card">
                      <div class="card-header" id="headingLineGood">
                        <h2 class="mb-0">
                          <button
                            class="btn btn-link collapsed"
                            type="button"
                            data-toggle="collapse"
                            data-target="#collapseLineGood"
                            aria-expanded="false"
                            aria-controls="collapseLineGood"
                          >
                            Linia dobrych połączeń (good)
                          </button>
                        </h2>
                      </div>
                      <div
                        id="collapseLineGood"
                        class="collapse"
                        aria-labelledby="headingLineGood"
                        data-parent="#accordionLines"
                      >
                        <div class="card-body">Linia dobrych połączeń (good)</div>
                      </div>
                    </div>
                    <div class="card">
                      <div class="card-header" id="headingLineBad">
                        <h2 class="mb-0">
                          <button
                            class="btn btn-link collapsed"
                            type="button"
                            data-toggle="collapse"
                            data-target="#collapseLineBad"
                            aria-expanded="false"
                            aria-controls="collapseLineBad"
                          >
                            Linia złych połączeń (bad)
                          </button>
                        </h2>
                      </div>
                      <div
                        id="collapseLineBad"
                        class="collapse"
                        aria-labelledby="headingLineBad"
                        data-parent="#accordionLines"
                      >
                        <div class="card-body">Linia złych połączeń (bad)</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="tab-pane fade" id="nav-points" role="tabpanel" aria-labelledby="nav-points-tab">PUNKTY</div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-8">
          <h2>Logika gry</h2>
          <div class="row">
            <div class="col-12">
              <canvas
                id="previewGame"
                class="border"
                @mousedown="moveContainerCanvas"
                @mouseup="stopMoveContainerCanvas"
              ></canvas>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import * as $ from 'jquery';
import 'bootstrap';
import 'bootstrap-colorpicker';

import MpGroupCJS from './MpGroupCJS';

import { preStage } from '../js/preStage.js';

import { Connect } from '../js/connect.js';
import { BaseEngine } from '../js/baseEngine.js';

export default {
  name: 'mp-connect',
  components: { 'mp-group-cjs': MpGroupCJS },
  props: {
    gameJS: {
      type: Object,
      default: function () {
        return new Connect(this.preStage);
      },
    },
  },
  data: function () {
    return {
      preStage: null,
      interval: false,
      next: 0,
    };
  },
  mounted() {
    this.initConnect();
    this.initPreStage();
  },

  methods: {
    onUpdateGame(gr) {
      if (gr.delete === true) {
        this.gameJS.removeGroup(gr.idGroup);
        this.preStage.removeGroup(gr.idGroup);
      } else {
        this.gameJS.updateGroup(gr);
        this.preStage.updateGroup(gr);
      }
      this.$emit('changeConfig', { gameJS: this.gameJS, preStage: this.preStage });
    },
    initConnect() {
      let self = this;
      $('#mp-connect').change(function (e) {
        self.$emit('changeConfig', { gameJS: self.gameJS, preStage: self.preStage });
      });
      $('.accordion').collapse();
    },
    addGroup(e) {
      this.gameJS.addGroup('gr' + this.next);
      this.next++;
    },
    initPreStage() {
      let self = this;
      try {
        if (this.preStage != null) {
          console.log('INIT_PRE_STAGE');
          this.preStage.beforeDestroy();
        }
        this.preStage = new preStage(this.gameJS.getConfigGame(), {
          getDefaultFont: this.$store.getters.getDefaultFont,
          multibookType: this.$store.getters.multibookType,
          idCanvas: 'previewGame',
        });
        if (this.preStage != null) {
          Promise.all(this.preStage._fonts)
            .catch((err) => {
              console.log(err);
            })
            .finally(() => {
              console.log('INIT CREATEJS');
              self.preStage.initGame();
              self.gameJS._preStage = self.preStage;
              self.preStage.configGroups = self.gameJS.layout.groups;
              // console.log(self.preStage.stage);
              // self.preStage.stage.on('mousedown', self.preStage.stageMouseDown);

              //         self.cjsStage.runFunctionEngine('afterLoadSamples');
              //         self.cjsStage.runFunctionEngine('defineKeys');
              //         self.runPromises();
            });
          self.$emit('changeConfig', { gameJS: self.gameJS, preStage: self.preStage });
        }
        console.log(this.preStage);
      } catch (e) {
        if (this.preStage != null) this.preStage.beforeDestroy();
        delete this.preStage;
        console.log('ZNOWU SIĘ ZJEBAŁO');
        console.log(e);
      }
    },
    moveContainerCanvas(e) {
      if (!this.interval) {
        let self = this;
        this.interval = setInterval(() => {
          for (let i = 0; i < self.gameJS.layout.groups.length; i++) {
            self.gameJS.layout.groups[i].positions.pos.x =
              self.preStage.groups[self.gameJS.layout.groups[i].idGroup]._posConfig.x;
            self.gameJS.layout.groups[i].positions.pos.y =
              self.preStage.groups[self.gameJS.layout.groups[i].idGroup]._posConfig.y;
          }
        }, 30);
      }
    },
    stopMoveContainerCanvas(e) {
      clearInterval(this.interval);
      this.interval = false;
    },
    giveMeImagePlease(path) {
      try {
        return require(`__staticDir/${this.$store.getters.multibookType}/${path}`);
      } catch (err) {
        console.log(err);
      }
    },
  },
  computed: {},
};
</script>
<style lang="sass">
.btn
  position: relative !important
</style>
<style lang="sass" scoped>
.tab-pane
  padding-top: 20px

.entry:not(:first-of-type)
  margin-top: 10px

#previewSource
  border: 2px solid black
  margin: 0 auto

#previewGame
  width: 100%
  height: 100%
  background-color: #ffffff
</style>
